module.exports = __webpack_public_path__ + "media/Room2.14b10c92.mp3";